import React, { useState, useEffect } from "react";
import { Wrapper, Button } from "../../components";

const KycKampanyasi = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [campaignStarted, setCampaignStarted] = useState(false);

  useEffect(() => {
    const startDate = new Date("May 15, 2025 00:00:00").getTime();
    const endDate = new Date("June 30, 2025 00:00:00").getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const toStart = startDate - now;
      const toEnd = endDate - now;

      // Kampanya başladı mı kontrol et
      if (now >= startDate && now < endDate) {
        setCampaignStarted(true);
        
        // Kampanya başladı, bitimine kalan süreyi hesapla
        setTimeLeft({
          days: Math.floor(toEnd / (1000 * 60 * 60 * 24)),
          hours: Math.floor((toEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((toEnd % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((toEnd % (1000 * 60)) / 1000)
        });
      } else if (now < startDate) {
        setCampaignStarted(false);
        
        // Kampanya henüz başlamadı, başlamasına kalan süreyi hesapla
        setTimeLeft({
          days: Math.floor(toStart / (1000 * 60 * 60 * 24)),
          hours: Math.floor((toStart % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((toStart % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((toStart % (1000 * 60)) / 1000)
        });
      } else {
        // Kampanya sona erdi
        setCampaignStarted(false);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    
    const interval = setInterval(updateCountdown, 1000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-dark-background min-h-screen">
      {/* Hero Section with Background */}
      <div className="relative">
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-primary/20 to-dark-background"></div>
        
        {/* Hero Content */}
        <div className="relative pt-8 pb-20">
          <Wrapper>
            <div className="flex flex-col md:flex-row items-center">
              {/* Left Content */}
              <div className="md:w-1/2 text-left md:pr-8">
                <div className="inline-flex items-center bg-dark-backgroundOnDark/80 backdrop-blur-sm rounded-full py-1.5 px-4 mb-4 border border-primary/30">
                  <span className="w-2 h-2 rounded-full bg-primary animate-pulse mr-2"></span>
                  <span className="text-primary text-sm font-medium">15 Mayıs - 30 Haziran 2025</span>
                </div>
                
                <h1 className="text-white text-3xl md:text-5xl font-bold mb-4 leading-tight">
                  <span className="text-primary">KYC</span> TAMAMLA <br />
                  <span className="text-2xl md:text-4xl">ÖDÜLÜNÜ KAZAN!</span>
                </h1>
                
                <p className="text-secondaryTwo text-lg mb-8 max-w-xl">
                  GMSKripto'da KYC doğrulama sürecini tamamla, <span className="text-primary font-bold">100 TL</span> ödül kazan ve ilk ay tüm işlemlerini <span className="text-primary font-bold">%0 komisyon</span> ile gerçekleştir!
                </p>
                
                <div className="mb-8">
                  <Button 
                    variant="primary" 
                    className="py-3 px-8 text-lg bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary shadow-lg shadow-primary/30 border-none"
                    onClick={() => window.location.href = "https://exchange.gmskripto.com/signin"}
                  >
                    KYC'Yİ TAMAMLA
                  </Button>
                </div>
                
                <div className="bg-dark-backgroundOnDark/40 backdrop-blur-sm p-3 rounded-lg border border-primary/20 inline-block">
                  <p className="text-white text-sm mb-2">
                    {campaignStarted 
                      ? "Kampanya Bitimine Kalan Süre:" 
                      : "Kampanya Başlamasına Kalan Süre:"}
                  </p>
                  <div className="flex gap-3">
                    <div className="flex flex-col items-center">
                      <div className="bg-dark-backgroundOnDark w-14 h-14 rounded-lg flex items-center justify-center text-white text-xl font-bold border border-primary/50">
                        {String(timeLeft.days).padStart(2, '0')}
                      </div>
                      <span className="text-secondaryTwo text-xs mt-1">GÜN</span>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="bg-dark-backgroundOnDark w-14 h-14 rounded-lg flex items-center justify-center text-white text-xl font-bold border border-primary/50">
                        {String(timeLeft.hours).padStart(2, '0')}
                      </div>
                      <span className="text-secondaryTwo text-xs mt-1">SAAT</span>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="bg-dark-backgroundOnDark w-14 h-14 rounded-lg flex items-center justify-center text-white text-xl font-bold border border-primary/50">
                        {String(timeLeft.minutes).padStart(2, '0')}
                      </div>
                      <span className="text-secondaryTwo text-xs mt-1">DAKİKA</span>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="bg-dark-backgroundOnDark w-14 h-14 rounded-lg flex items-center justify-center text-white text-xl font-bold border border-primary/50">
                        {String(timeLeft.seconds).padStart(2, '0')}
                      </div>
                      <span className="text-secondaryTwo text-xs mt-1">SANİYE</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Right Content - Illustration/Image */}
              <div className="md:w-1/2 mt-10 md:mt-0 relative">
                <div className="relative">
                  {/* Abstract shapes */}
                  <div className="absolute -top-10 -right-10 w-32 h-32 bg-primary/10 rounded-full blur-xl"></div>
                  <div className="absolute bottom-10 -left-10 w-24 h-24 bg-primary/20 rounded-full blur-lg"></div>
                  
                  {/* Main feature image placeholder */}
                  <div className="relative bg-dark-backgroundOnDark border border-primary/30 rounded-2xl p-6 backdrop-blur-sm">
                    <div className="absolute -top-4 -right-4 bg-primary/80 text-white text-sm font-bold py-1 px-3 rounded-full">
                      Yeni Kullanıcılara Özel
                    </div>
                    
                    <div className="flex items-center justify-center h-60 mb-4">
                      {/* Füturistik 100 TL bonus görseli */}
                      <div className="relative w-48 h-48">
                        {/* Dış çember animasyonu */}
                        <div className="absolute inset-0 w-full h-full rounded-full border-4 border-primary/30 animate-pulse"></div>
                        
                        {/* Orta çember */}
                        <div className="absolute inset-2 w-[calc(100%-16px)] h-[calc(100%-16px)] rounded-full bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
                          {/* İç çember */}
                          <div className="relative w-36 h-36 rounded-full bg-dark-backgroundOnDark border border-primary/40 flex items-center justify-center overflow-hidden">
                            {/* Parlama efekti */}
                            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-20 bg-primary/30 blur-xl"></div>
                            
                            {/* 100 TL yazısı */}
                            <div className="relative z-10 flex flex-col items-center">
                              <span className="text-4xl font-bold text-white">100</span>
                              <span className="text-2xl font-bold text-primary">TL</span>
                              <span className="text-xs text-primary/80 uppercase tracking-wider mt-1">KAZAN</span>
                            </div>
                          </div>
                        </div>
                        
                        {/* Dekoratif elementler */}
                        <div className="absolute top-0 left-0 w-4 h-4 bg-primary rounded-full"></div>
                        <div className="absolute bottom-4 right-0 w-6 h-6 bg-primary/40 rounded-full"></div>
                        <div className="absolute top-1/4 right-0 w-3 h-3 bg-primary/60 rounded-full"></div>
                        
                        {/* Çizgiler */}
                        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
                          <path d="M20,50 L35,50" stroke="rgba(var(--color-primary), 0.6)" strokeWidth="0.5" />
                          <path d="M65,50 L80,50" stroke="rgba(var(--color-primary), 0.6)" strokeWidth="0.5" />
                          <path d="M50,20 L50,35" stroke="rgba(var(--color-primary), 0.6)" strokeWidth="0.5" />
                          <path d="M50,65 L50,80" stroke="rgba(var(--color-primary), 0.6)" strokeWidth="0.5" />
                        </svg>
                        
                        {/* Dijital para sembolü */}
                        <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-primary">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    
                    <div className="text-center">
                      <h3 className="text-white text-xl font-bold mb-2">100 TL KAZAN</h3>
                      <p className="text-secondaryTwo">Üye ol,KYC'ni tamamla, 100 TL kazan!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </div>
      </div>
      
      {/* Features Section */}
      <div className="py-16 bg-dark-backgroundOnDark/30">
        <Wrapper>
          <div className="text-center mb-14">
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">Nasıl Katılabilirsin?</h2>
            <p className="text-secondaryTwo max-w-2xl mx-auto">Sadece üç adımda ödülünü kazanabilir ve komisyonsuz işlem avantajından yararlanabilirsin.</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Step 1 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-6 border border-dark-line relative">
              <div className="absolute -top-5 -left-5 w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-bold text-lg">1</div>
              <div className="pt-6">
                <h3 className="text-white text-xl font-bold mb-3">Kayıt Ol</h3>
                <p className="text-secondaryTwo mb-4">GMSKripto'ya yeni bir hesap oluşturarak kayıt ol.</p>
                <div className="h-24 bg-dark-background/50 rounded-lg flex items-center justify-center mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 text-primary/70">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Step 2 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-6 border border-dark-line relative">
              <div className="absolute -top-5 -left-5 w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-bold text-lg">2</div>
              <div className="pt-6">
                <h3 className="text-white text-xl font-bold mb-3">KYC'yi Tamamla</h3>
                <p className="text-secondaryTwo mb-4">Kimlik doğrulama adımlarını eksiksiz tamamla.</p>
                <div className="h-24 bg-dark-background/50 rounded-lg flex items-center justify-center mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 text-primary/70">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Step 3 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-6 border border-dark-line relative">
              <div className="absolute -top-5 -left-5 w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-bold text-lg">3</div>
              <div className="pt-6">
                <h3 className="text-white text-xl font-bold mb-3">Ödülünü Kazan</h3>
                <p className="text-secondaryTwo mb-4">100 TL bonusunu al ve komisyonsuz işlem yap.</p>
                <div className="h-24 bg-dark-background/50 rounded-lg flex items-center justify-center mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 text-primary/70">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      </div>
      
      {/* Mobile App Download Section */}
      <div className="py-16 bg-gradient-to-b from-dark-background to-dark-backgroundOnDark/50">
        <Wrapper>
          <div className="text-center mb-10">
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">Dijital KYC İçin Mobil Uygulamamızı İndir</h2>
            <p className="text-secondaryTwo max-w-2xl mx-auto">
              Dijital KYC işlemi sadece NFC özellikli mobil cihazlar üzerinden yapılabilmektedir. 
              Hemen mobil uygulamamızı indirerek hızlı ve güvenli bir şekilde kimlik doğrulama işleminizi tamamlayabilirsiniz.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Left Side - App Features */}
            <div className="md:w-1/2">
              <div className="bg-dark-backgroundOnDark rounded-xl p-6 border border-primary/20">
                <h3 className="text-white text-xl font-bold mb-4">Neden Mobil Uygulama ile KYC?</h3>
                
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <div className="mt-1 bg-primary/10 rounded-full p-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 text-primary">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    </div>
                    <p className="text-secondaryTwo">
                      <span className="text-white font-medium">NFC Teknolojisi:</span> Kimlik kartınızdaki çipi okuyarak %100 doğru bilgi aktarımı sağlar.
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="mt-1 bg-primary/10 rounded-full p-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 text-primary">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    </div>
                    <p className="text-secondaryTwo">
                      <span className="text-white font-medium">Anında Onay:</span> Otomatik dijital KYC sistemi sayesinde anında onay alabilirsiniz.
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="mt-1 bg-primary/10 rounded-full p-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 text-primary">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    </div>
                    <p className="text-secondaryTwo">
                      <span className="text-white font-medium">Güvenli İşlem:</span> Verileriniz şifrelenerek aktarılır ve güvenliğiniz maksimum seviyede tutulur.
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="mt-1 bg-primary/10 rounded-full p-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 text-primary">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    </div>
                    <p className="text-secondaryTwo">
                      <span className="text-white font-medium">Hızlı Süreç:</span> Tüm KYC sürecini sadece 5 dakika içinde tamamlayabilirsiniz.
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="mt-1 bg-primary/10 rounded-full p-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 text-primary">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    </div>
                    <p className="text-secondaryTwo">
                      <span className="text-white font-medium">Yasal Uyum:</span> Dijital KYC doğrulaması yapılması, yeni çıkan regülasyon ve uyum yasaları sebebiyle artık zorunludur.
                    </p>
                  </li>
                </ul>
                
                <div className="mt-6 p-4 bg-primary/10 rounded-lg border border-primary/30">
                  <p className="text-white text-sm">
                    <span className="font-bold">Not:</span> Dijital KYC işlemi için NFC özellikli akıllı telefon ve yeni nesil çipli kimlik kartı gerekmektedir.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Right Side - App Download */}
            <div className="md:w-1/2 flex flex-col items-center">
              <div className="relative w-64 h-64 mb-8">
                {/* Mobil uygulama görseli */}
                <div className="absolute inset-0 bg-dark-backgroundOnDark rounded-3xl border-4 border-primary/30 overflow-hidden shadow-xl">
                  <div className="absolute top-0 left-0 right-0 h-10 bg-dark-backgroundOnDark flex items-center justify-center">
                    <div className="w-20 h-5 bg-dark-background rounded-full"></div>
                  </div>
                  <div className="absolute top-14 left-4 right-4 bottom-4 bg-primary/5 rounded-lg flex items-center justify-center">
                    <div className="text-center">
                      <div className="w-16 h-16 bg-primary/20 rounded-full mx-auto flex items-center justify-center mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                        </svg>
                      </div>
                      <p className="text-white font-bold">GMSKripto</p>
                      <p className="text-primary text-xs">Dijital KYC</p>
                    </div>
                  </div>
                </div>
                
                {/* Dekoratif elementler */}
                <div className="absolute -top-4 -right-4 w-20 h-20 bg-primary/10 rounded-full blur-lg"></div>
                <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-primary/10 rounded-full blur-lg"></div>
              </div>
              
              <div className="flex flex-col items-center gap-4">
                <h3 className="text-white text-xl font-bold">Hemen İndir</h3>
                
                <div className="flex flex-col sm:flex-row gap-4">
                  {/* Google Play Button */}
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.gmskripto.exchange&hl=tr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-dark-backgroundOnDark hover:bg-dark-backgroundOnDark/80 transition-colors px-6 py-3 rounded-lg border border-dark-line"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-white">
                      <path d="M5.26 3.795L14.055 12 5.26 20.205c-.337-.356-.52-.822-.52-1.31V5.106c0-.487.183-.953.52-1.31zM7.27 2.5a1.78 1.78 0 0 1 1.218.48l8.77 8.24c.274.258.428.612.428.98s-.154.722-.428.98l-8.77 8.24c-.33.31-.76.48-1.218.48-.194 0-.387-.03-.57-.09a1.78 1.78 0 0 1-1.2-1.69V4.28c0-.77.46-1.43 1.2-1.69.183-.06.376-.09.57-.09zm8.32 5.823l-2.032 2.036 2.032 2.036 2.517-1.5c.274-.16.443-.456.443-.777s-.17-.617-.443-.777l-2.517-1.5zm-8.937 5.568l2.882-2.7-2.882-2.7-3.08 1.834c-.33.2-.533.55-.533.935s.202.737.533.936l3.08 1.834z"/>
                    </svg>
                    <div className="text-left">
                      <div className="text-secondaryTwo text-xs">İNDİR</div>
                      <div className="text-white font-medium">Google Play</div>
                    </div>
                  </a>
                  
                  {/* App Store Button */}
                  <a 
                    href="https://apps.apple.com/tr/app/gmskripto-exchange/id6504996507" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-dark-backgroundOnDark hover:bg-dark-backgroundOnDark/80 transition-colors px-6 py-3 rounded-lg border border-dark-line"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-white">
                      <path d="M14.94 5.19A4.18 4.18 0 0 0 16 2a4.3 4.3 0 0 0-2.88 1.48 3.95 3.95 0 0 0-1 2.92 3.51 3.51 0 0 0 2.82-1.21zM18.44 12.63a4.56 4.56 0 0 1 2.18-3.82 4.65 4.65 0 0 0-3.68-2c-1.56-.16-3.06.92-3.85.92s-2-.9-3.31-.87a4.87 4.87 0 0 0-4.11 2.5c-1.75 3-.45 7.5 1.26 10 .84 1.2 1.84 2.54 3.15 2.49s1.75-.81 3.29-.81 2 .81 3.32.78 2.22-1.23 3.06-2.43a10.96 10.96 0 0 0 1.38-2.85 4.4 4.4 0 0 1-2.7-4.01z"/>
                    </svg>
                    <div className="text-left">
                      <div className="text-secondaryTwo text-xs">İNDİR</div>
                      <div className="text-white font-medium">App Store</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      </div>
      
      {/* Benefits Section */}
      <div className="py-16">
        <Wrapper>
          <div className="text-center mb-14">
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">Neden Katılmalısın?</h2>
            <p className="text-secondaryTwo max-w-2xl mx-auto">GMSKripto KYC kampanyasının sunduğu eşsiz avantajlardan yararlan.</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Benefit 1 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-8 border border-dark-line hover:border-primary/30 transition-colors">
              <div className="flex items-start gap-6">
                <div className="bg-primary/10 rounded-full p-4">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white text-xl font-bold mb-3">100 TL Bonus</h3>
                  <p className="text-secondaryTwo">
                    KYC sürecini tamamladığın anda otomatik olarak 100 TL bonus almaya hak kazanırsın. Bu bonus ile istediğin kripto para birimini satın alabilirsin veya çekim yapabilirsin.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Benefit 2 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-8 border border-dark-line hover:border-primary/30 transition-colors">
              <div className="flex items-start gap-6">
                <div className="bg-primary/10 rounded-full p-4">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white text-xl font-bold mb-3">%0 Komisyon Fırsatı</h3>
                  <p className="text-secondaryTwo">
                    Üyeliğinin ilk 30 günü boyunca tüm alım-satım işlemlerinde %0 komisyon avantajından yararlanırsın. Bu fırsat ile daha kârlı işlemler gerçekleştirebilirsin.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Benefit 3 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-8 border border-dark-line hover:border-primary/30 transition-colors">
              <div className="flex items-start gap-6">
                <div className="bg-primary/10 rounded-full p-4">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white text-xl font-bold mb-3">Güvenli İşlem Ortamı</h3>
                  <p className="text-secondaryTwo">
                    KYC sürecini tamamlayarak, hesabını yerel regülasyonlara uygun hale getirirsin. Ayrıca güvenli bir işlem ortamı elde edersin. Hesabın tam korumalı hale gelir ve tüm işlemlerin güvence altına alınır.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Benefit 4 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-8 border border-dark-line hover:border-primary/30 transition-colors">
              <div className="flex items-start gap-6">
                <div className="bg-primary/10 rounded-full p-4">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white text-xl font-bold mb-3">Otomatik Dijital KYC</h3>
                  <p className="text-secondaryTwo">
                    GMSKripto'da KYC onay süreci tamamen dijital ve otomatiktir. Otomatik onay süreci sayesinde vakit kaybetmeden işlemlerine başlayabilirsin.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      </div>
      
      {/* FAQ Section */}
      <div className="py-16 bg-dark-backgroundOnDark/30">
        <Wrapper>
          <div className="text-center mb-14">
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">Sıkça Sorulan Sorular</h2>
            <p className="text-secondaryTwo max-w-2xl mx-auto">Kampanya ile ilgili merak ettiklerinin cevaplarını buradan bulabilirsin.</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {/* FAQ Item 1 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-6 border border-dark-line">
              <h3 className="text-white text-lg font-semibold mb-3">KYC nedir ve neden gereklidir?</h3>
              <p className="text-secondaryTwo">
                KYC (Know Your Customer), kullanıcıların kimliğini doğrulayan bir süreçtir. Bu süreç kripto para platformlarında güvenliği artırmak, dolandırıcılığı önlemek ve yasal düzenlemelere uymak için gereklidir.
              </p>
            </div>
            
            {/* FAQ Item 2 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-6 border border-dark-line">
              <h3 className="text-white text-lg font-semibold mb-3">KYC doğrulama süreci ne kadar sürer?</h3>
              <p className="text-secondaryTwo">
                GMSKripto'da KYC doğrulama sürecini tamamlamanız genellikle 5 dakika sürer, eğer tüm adımları doğru bir şekilde tamamlarsanız, kimliğiniz anında onaylanır. </p>
            </div>
            
            {/* FAQ Item 3 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-6 border border-dark-line">
              <h3 className="text-white text-lg font-semibold mb-3">100 TL bonusu nasıl kullanabilirim?</h3>
              <p className="text-secondaryTwo">
                Kampanya sonunda kazanılan 100 TL bonusu dilediğin kripto para birimini satın almak için kullanabilirsin. Veya direkt TL hesabına çekim yapabilirsin.
              </p>
            </div>
            
            {/* FAQ Item 4 */}
            <div className="bg-dark-backgroundOnDark rounded-xl p-6 border border-dark-line">
              <h3 className="text-white text-lg font-semibold mb-3">Komisyonsuz işlem hakkı tam olarak ne içerir?</h3>
              <p className="text-secondaryTwo">
                Komisyonsuz işlem hakkı, ilk 30 gün içinde yapacağın TRY marketlerindeki tüm spot alım-satım işlemlerinde geçerlidir. Bu süre içinde işlem hacmin ne olursa olsun %0 komisyon uygulanır.
              </p>
            </div>
          </div>
        </Wrapper>
      </div>
      
      {/* Terms and Conditions */}
      <div className="py-16">
        <Wrapper>
          <div className="bg-dark-backgroundOnDark rounded-xl p-8">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-white text-2xl font-bold">Şartlar ve Koşullar</h2>
              <button className="text-white">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
            </div>
            
            <div className="text-secondaryTwo space-y-4">
              <div className="flex gap-3">
                <span className="text-primary font-bold">1.</span>
                <p>Bu etkinlik, 15 Mayıs 2025 saat 00:00 (TSİ) tarihinde başlayacak, 30 Haziran 2025 saat 00:00 (TSİ) tarihinde sona erecek ve GMSKripto kullanıcılarına özeldir.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">2.</span>
                <p>Bu kampanya yalnızca KYC onayını tamamlayan kullanıcılara yöneliktir. Etkinlik için KYC seviyesi kontrolü yapılacaktır.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">3.</span>
                <p>Kullanıcıların etkinliğe katılabilmesi için MOBİL UYGULAMADAN "Dijital Kyc" butonuna tıklayarak KYC sürecini başlatmaları gerekmektedir.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">4.</span>
                <p>Kullanıcıların etkinlikten faydalanabilmesi için GMSKripto'da KYC doğrulama sürecini kampanya süresi içinde tamamlamaları gerekmektedir.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">5.</span>
                <p>Kullanıcılar KYC sürecini başarıyla tamamladıklarında 100 TL ödül ve ilk ay için komisyonsuz işlem avantajı kazanacaklardır. Sadece tam ve doğru bilgilerle tamamlanan KYC süreçleri geçerli sayılacaktır.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">6.</span>
                <p>Kampanya için ayrılan toplam ödül havuzu 1.000.000 TL'dir. Bir kullanıcı maksimum 100 TL ödül kazanabilir. Ödüller Türk Lirası cinsinden dağıtılacaktır.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">7.</span>
                <p>KYC onayı sonrası kazanılan ödüller, kampanyanın tamamlanmasının ardından 10 iş günü içerisinde kullanıcıların hesaplarına tanımlanacaktır.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">8.</span>
                <p>Çakışan tarihlerde 2 veya daha fazla GMSKripto etkinliğine katılan ve farklı etkinliklerde aynı görevleri yerine getiren kullanıcılar, aynı görev için yalnızca bir etkinlikten (en yüksek ödül aldığı etkinlikten) ödül almaya hak kazanabilecektir.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">9.</span>
                <p>GMSKripto; kampanya süresince ekstra ödül elde etmek amacıyla toplu hesap kaydı ve yasalara aykırı, sahtekârlık içeren veya zarar verici amaçlar güden diğer her türlü eylem dâhil olmak üzere dürüst olmayan ya da kötüye kullanım içeren eylemlerde bulunan katılımcıları diskalifiye etme hakkını saklı tutar.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">10.</span>
                <p>Avrupa Ekonomik Alanı'ndaki (AEA) kullanıcılar, yerel düzenlemeler nedeniyle bu kampanyadan faydalanamayabilirler.</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">11.</span>
                <p>GMSKripto, kullanıcıları önceden bilgilendirmeksizin bu kampanyanın şartlarını ve koşullarını değiştirme hakkını saklı tutar. GMSKripto, bu kampanyanın şartlarını ve koşullarını nihai olarak yorumlama hakkını saklı tutar.</p>
              </div>
            </div>
          </div>
          
          {/* CTA Button */}
          <div className="mt-12 text-center">
            <Button 
              variant="primary" 
              className="py-4 px-10 text-lg bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary shadow-lg shadow-primary/30 border-none"
              onClick={() => window.location.href = "https://exchange.gmskripto.com/signin"}
            >
              Hemen KYC'ni Tamamla
            </Button>
            <p className="text-secondaryTwo mt-4">
              Sorularınız için <span className="text-primary">destek@gmskripto.com</span> adresine e-posta gönderebilirsiniz.
            </p>
          </div>
        </Wrapper>
      </div>
    </div>
  );
};

export default KycKampanyasi;